import React from 'react'

import { Button } from '@/components/buttons/Button'
import { BasicModal } from '@/components/layout/modals/BasicModal'

const TITLE = "We're scanning your folder structure"
const BODY =
  "Come back later. This typically takes an hour. We'll send you a notification when it's ready."
const DISMISS_LABEL = 'Got it'

/**
 * @param {object} props
 * @param {Function} props.onClose Called when the notice is dismissed, by Got it or the header close
 */
export const ScanningModal = ({ onClose }) => (
  <BasicModal
    show
    size="small"
    title={TITLE}
    data-testid="scanning-modal"
    onClose={onClose}
    footer={
      <Button className="ml-auto" onClick={onClose}>
        {DISMISS_LABEL}
      </Button>
    }
  >
    <p>{BODY}</p>
  </BasicModal>
)
